// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .totals{ */
/* background-color: #fff; */
/* } */
.FirstRowBoxes {
  display: flex;
  flex-direction: row;
  text-align: left;
  gap: 40px;
  margin-left: 40px;
  margin-top: -7px;
}

.SecondRowBoxes {
  display: flex;
  flex-direction: row;
  text-align: left;
  gap: 40px;
  margin-left: 40px;
  margin-top: 35px;
}

.ThirdRowBoxes {
  display: flex;
  flex-direction: row;
  text-align: left;
  gap: 40px;
  margin-left: 40px;
  margin-top: 35px;
  margin-bottom: 35px;
}

.await h3 {
  margin-top: -3px;
}

.cpu h3 {
  margin-top: -3px;
}

.system h3 {
  margin-top: -3px;
}

.memory h3 {
  margin-top: -3px;
}

.space h3 {
  margin-top: -3px;
}

.DiskRead h3 {
  margin-top: -3px;
}

.DiskWrite h3 {
  margin-top: -3px;
}

.out h3 {
  margin-top: -3px;
}

.in h3 {
  margin-top: -3px;
}

.upperButtonsGroup {
  display: flex;
  margin-left: 1px;
}

.upperButtons button {
  height: 30px;
  border: 50px;
  gap: 0px;
  border-color: red;
  border-radius: 20px;
  background-color: rgb(255, 249, 249);
  color: red;
  margin-top: 23px;
}

/* .totals {
  height: 100vh;
  margin-left: 0px;
} */
.totaldiv {
  /* height: 100vh; */
  margin-left: 0px;
}

.hamburger {
  display: none;
}

.totals h1 {
  text-align: left;
}

.totaldiv h1 {
  text-align: left;
  margin-left: 63px;
  padding-top: 10px;
}

.upperButtons {
  margin-top: -17px;
  margin-left: -1211px;
}

.totals h1 {
  padding-left: 20px;
}

.tabs {
  padding-left: 15px;
}`, "",{"version":3,"sources":["webpack://./components/Details/Details.css"],"names":[],"mappings":"AAAA,aAAA;AACA,4BAAA;AACA,MAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,gBAAA;AAAF;;AAGA;EACE,YAAA;EACA,YAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,oCAAA;EACA,UAAA;EACA,gBAAA;AAAF;;AAGA;;;GAAA;AAIA;EACE,mBAAA;EACA,gBAAA;AAAF;;AAEA;EACE,aAAA;AACF;;AACA;EACE,gBAAA;AAEF;;AAAA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;AAGF;;AAAA;EACE,iBAAA;EACA,oBAAA;AAGF;;AAAA;EACE,kBAAA;AAGF;;AAAA;EACE,kBAAA;AAGF","sourcesContent":["/* .totals{ */\n/* background-color: #fff; */\n/* } */\n\n.FirstRowBoxes {\n  display: flex;\n  flex-direction: row;\n  text-align: left;\n  gap: 40px;\n  margin-left: 40px;\n  margin-top: -7px;\n}\n\n.SecondRowBoxes {\n  display: flex;\n  flex-direction: row;\n  text-align: left;\n  gap: 40px;\n  margin-left: 40px;\n  margin-top: 35px;\n}\n\n.ThirdRowBoxes {\n  display: flex;\n  flex-direction: row;\n  text-align: left;\n  gap: 40px;\n  margin-left: 40px;\n  margin-top: 35px;\n  margin-bottom: 35px;\n}\n\n.await h3 {\n  margin-top: -3px;\n}\n\n.cpu h3 {\n  margin-top: -3px;\n}\n\n.system h3 {\n  margin-top: -3px;\n}\n\n.memory h3 {\n  margin-top: -3px;\n}\n\n.space h3 {\n  margin-top: -3px;\n}\n\n.DiskRead h3 {\n  margin-top: -3px;\n}\n\n.DiskWrite h3 {\n  margin-top: -3px;\n}\n\n.out h3 {\n  margin-top: -3px;\n}\n\n.in h3 {\n  margin-top: -3px;\n}\n\n.upperButtonsGroup {\n  display: flex;\n  margin-left: 1px;\n}\n\n.upperButtons button {\n  height: 30px;\n  border: 50px;\n  gap: 0px;\n  border-color: red;\n  border-radius: 20px;\n  background-color: rgb(255, 249, 249);\n  color: red;\n  margin-top: 23px;\n}\n\n/* .totals {\n  height: 100vh;\n  margin-left: 0px;\n} */\n.totaldiv {\n  /* height: 100vh; */\n  margin-left: 0px;\n}\n.hamburger {\n  display: none;\n}\n.totals h1 {\n  text-align: left;\n}\n.totaldiv h1 {\n  text-align: left;\n  margin-left: 63px;\n  padding-top: 10px;\n}\n\n.upperButtons {\n  margin-top: -17px;\n  margin-left: -1211px;\n}\n\n.totals h1 {\n  padding-left: 20px;\n}\n\n.tabs {\n  padding-left: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
